import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import InvitationOverview from "./sections/InvitationOverview";
import Introduction from "./sections/Introduction";
import Courses from "./sections/Courses";
import ServicesNavigationGrid from "./sections/ServicesNavigationGrid";
import Diferencial from "./sections/Diferencial";
import SeoLocal from "./sections/SeoLocal";
import ReadyToStartYourOrder from "./sections/ReadyToStartYourOrder";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <InvitationOverview />
      <Introduction />
      <Courses />
      <ServicesNavigationGrid />
      <Diferencial />
      <SeoLocal />
      <ReadyToStartYourOrder />
      <Footer />
    </div>;
}